import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { MaterialBottomSheetLink } from '../../../business/material-bottom-sheet/material-bottom-sheet-link';

@Component({
    selector: 'ecm-mat-bottom-sheet-link-items',
    templateUrl: 'material-bottom-sheet-link-items.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialBottomSheetLinkItemsComponent {
    public items = input<MaterialBottomSheetLink[]>([]);
    public clickLink = output<MaterialBottomSheetLink>();
}
